const SavedTabViews = self => ({

  get allContacts() {
    if (self.savedContacts.size === 0) { return []; }

    return Array.from(self.savedContacts.values());
  },

  get selectedContact() {
    return self.savedContacts.get(self.selectedContactId);
  },

  get selectedCompanyContact() {
    return self.savedContacts.get(self.selectedContactId)?.company;
  },

  get listNameBySelectedList() {
    return self.allLists.find(list => list.listKey === self.selectedList)?.name;
  },
});

export default SavedTabViews;
